import { useEffect } from 'react'

export const useClickEventListener = ({
  remarkId,
  setIsEditToolPopupOpened,
}: {
  remarkId: string
  setIsEditToolPopupOpened: (isOpen: boolean) => void
}) => {
  useEffect(() => {
    const container = document.getElementById('container')

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const listenerCallback = (e) => {
      const isShouldCloseEditToolPopup =
        e.currentTarget.id !== remarkId &&
        e.target.className !== 'edit-tool-popup-container' &&
        e.target.className !== 'edit-tool-popup-item' &&
        e.target.id !== `dots${remarkId}`

      if (isShouldCloseEditToolPopup) {
        setIsEditToolPopupOpened(false)
      }
    }

    container?.addEventListener('click', listenerCallback)
    return () => container?.removeEventListener('click', listenerCallback)
  }, [])
}
